import { MenuItem as MuiMenuItem } from "@mui/material";
import { ComponentProps } from "react";
import { useDialogProviderContext } from "..";

//Menu Item for Operation Menu
type MenuItemProps = ComponentProps<typeof MuiMenuItem>;

const MenuItem = (props: MenuItemProps) => {
  const { setIsOpen } = useDialogProviderContext();
  return <MuiMenuItem onClick={() => setIsOpen(true)} {...props} />;
};

export default MenuItem;
